import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import {
  trigger,
  style,
  animate,
  transition,
  state,
} from '@angular/animations';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _moment from 'moment';
const moment = _moment;
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.scss'],
  animations: [
    trigger('simpleFadeAnimation', [
      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [style({ opacity: 0 }), animate(300)]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave', animate(300, style({ opacity: 0 }))),
    ]),
  ],
})
export class SmsComponent implements OnInit {
  items: any = [];
  item;
  isLoading = false;
  Errors = null;
  data = null;
  templates;
  temp;
  templateModes: any = [];
  load: any = [];
  prev: any = [];
  tempEmail;
  htmlContent = '';
  isVisible: boolean = false;
  filteredItems;
  mode = 'form';
  itemSelected;
  service;
  DateToSend;
  fileName = 'ExcelSheet.xlsx';
  preLoad: boolean = false;
  startDate = '';
  endDate = '';
  minAge = '';
  maxAge = '';
  gender = '';
  private _searchText: string;

  get searchText(): string {
    return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filteredItems = this.filterItems(value);
  }

  filterItems(searchString: string) {
    return this.items.filter(
      (item) =>
        item.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1
    );
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '300px',
    minHeight: '300px',
    maxHeight: '300px',
    width: 'auto',
    minWidth: 'auto',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat'],
    ],
  };

  Form = new FormGroup({
    templateId: new FormControl(0, Validators.required),
    senderName: new FormControl(
      localStorage.getItem('username'),
      Validators.required
    ),
    UsersData: new FormControl('', Validators.required),
    MessageBody: new FormControl('', Validators.required),
  });
  templateForm = new FormGroup({
    Id: new FormControl(0, Validators.required),
    Title: new FormControl('', Validators.required),
    Body: new FormControl('', Validators.required),
  });

  DateChangeStart(event: any) {
    let date =
      moment(event.target.value).format('YYYY-MM-DD') + 'T00:00:00.000Z';
    this.startDate = date;
  }

  DateChangeEnd(event: any) {
    let date =
      moment(event.target.value).format('YYYY-MM-DD') + 'T00:00:00.000Z';
    this.endDate = date;
  }

  togle() {
    this.isVisible = !this.isVisible;
  }
  setitem(item) {
    this.Form.patchValue({
      ItemOfServiceId: item.id,
    });
    this.item = item.name;
    this.isVisible = false;
    console.log(this.Form.value);
  }

  constructor(public auth: SettingsService, private _snackBar: MatSnackBar) {}

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    console.log(this.templateForm.value);
    const { Id, Mode, Name, Item_Of_Service_Id, Template_Text } =
      this.templateForm.value;
    this.auth
      .postDocument(Id, Mode, Name, Item_Of_Service_Id, Template_Text)
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;

          if (this.data.success) {
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.isLoading = false;
            this._snackBar.open('Error please try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            console.log('error');
          }
        },
        (resErr) => {
          this.isLoading = false;
          this._snackBar.open('Error please your internet and try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  preview() {
    this.preLoad = true;
    let gender = this.gender;
    let minAge = +this.minAge;
    let maxAge = +this.maxAge;
    let startDate = this.startDate;
    let endDate = this.endDate;
    console.log(gender, minAge, maxAge, startDate, endDate);

    let pageno = 1;
    let pagesize = 8000;
    this.auth.preview(gender, minAge, maxAge, startDate, endDate).subscribe(
      (resSuccess: any) => {
        this.prev = resSuccess.recordset;
        this.load = resSuccess;
        this.preLoad = false;
        console.log(resSuccess);
        console.log(resSuccess.recordset);

        if (resSuccess.recordset.length > 0) {
          this._snackBar.open('Successfull', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.isLoading = false;
          this._snackBar.open('No data found', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resSuccess);
        }
      },
      (resErr) => {
        this.isLoading = false;
        this._snackBar.open('Error: check your internet and try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }
  Submit(e) {
    this.isLoading = true;
    this.Errors = null;
    this.Form.patchValue({
      UsersData: JSON.stringify(this.prev),
    });
    console.log(this.Form.value);
    const { templateId, senderName, UsersData } = this.Form.value;
    this.auth.sendSMS(templateId, senderName, UsersData).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess;
        this.isLoading = false;

        if (resSuccess.isSuccessful) {
          this._snackBar.open('Sent Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.Form.reset();
        } else {
          this.isLoading = false;
          this._snackBar.open('Error please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log('error');
        }
      },
      (resErr) => {
        this.isLoading = false;
        this._snackBar.open('Error please check internet and try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  ngOnInit(): void {
    const currentDate = moment(new Date()).format('YYYY/MM/DD');

    let splitCurrentDate = currentDate.split('/');
    console.log(splitCurrentDate);

    let currentYear = +splitCurrentDate[0];
    let month = +splitCurrentDate[1];
    let day = +splitCurrentDate[1];
    let formatYear = new Date(currentYear, month, day);
    this.DateToSend = formatYear;

    // this.stateForm.patchValue({
    //   age: age
    // })
    // this.date =""

    this.auth.getItems().subscribe(
      (resSuccess) => {
        this.items = resSuccess;
        this.filteredItems = this.items;
        this.isLoading = false;
      },
      (resErr) => {}
    );

    this.auth.gettemplates1().subscribe(
      (resSuccess: any) => {
        this.templates = resSuccess.recordset;
        this.isLoading = false;
        console.log(this.templates);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.gettemplatesMode('SMS').subscribe(
      (resSuccess) => {
        this.templateModes = resSuccess;
        this.isLoading = false;
        console.log(this.templateModes);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  setTemplate(template) {
    this.Form.patchValue({
      MessageBody: template.Body,
      templateId: template.Id,
    });
    // this.auth.gettemplatesDetail(template.Id).subscribe(
    //   (resSuccess) => {
    //     this.temp = resSuccess;
    //     this.Form.patchValue({
    //       MessageBody: this.temp.Template_Text,
    //     });
    //     this.isLoading = false;
    //   },
    //   (resErr) => {
    //     this.isLoading = false;
    //     this.Errors = resErr;
    //     this.Form.patchValue({
    //       MessageBody: 'error loading data',
    //     });
    //   }
    // );
  }

  setTemplateEmail(template) {
    this.templateForm.patchValue({
      Template_Text: template.Body,
      Name: template.Title,
      Id: template.Id,
    });
  }

  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
}
